// @ts-nocheck
import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defaultClassPrefix, getUnhandledProps, prefix } from './utils';
import TableContext from './TableContext';
class CellGroup extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.addPrefix = (name) => prefix(this.props.classPrefix)(name);
    }
    render() {
        const { fixed, width, left, height, style, classPrefix, className, children, ...rest } = this.props;
        const classes = classNames(classPrefix, className, {
            [this.addPrefix(`fixed-${fixed || ''}`)]: fixed,
            [this.addPrefix('scroll')]: !fixed,
        });
        const styles = {
            width,
            height,
            ...style,
        };
        const unhandledProps = getUnhandledProps(CellGroup, rest);
        return (React.createElement(TableContext.Consumer, null, ({ translateDOMPositionXY }) => {
            translateDOMPositionXY?.(styles, left, 0);
            return (React.createElement("div", Object.assign({}, unhandledProps, { className: classes, style: styles }), children));
        }));
    }
}
CellGroup.propTypes = {
    fixed: PropTypes.oneOf(['left', 'right']),
    width: PropTypes.number,
    height: PropTypes.number,
    left: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string,
    classPrefix: PropTypes.string,
};
CellGroup.defaultProps = {
    classPrefix: defaultClassPrefix('performance-table-cell-group'),
};
export default CellGroup;
